// Columnas de tabla estándar. Los ids coinciden con el catálogo del backend (features/precios/precios.tabla.js).
// Generado con apis-node/scripts/columnas-front.mjs: si se añade una columna allí, se regenera aquí
// (el backend rechaza ids que no conozca).

export const COLUMNAS_PRECIOS = [
  {
    id: 'idcentro',
    label: 'ID centro',
    width: 100,
    sortable: true,
    filter: 'text',
    align: 'right',
    defaultVisible: false,
    group: 'Curso',
  },
  {
    id: 'empresaId',
    label: 'Empresa',
    width: 120,
    sortable: true,
    filter: 'multi',
    group: 'General',
  },
  { id: 'centro', label: 'Sede', width: 190, sortable: true, filter: 'multi', group: 'Curso' },
  {
    id: 'codigocurso',
    label: 'Código',
    width: 130,
    sortable: true,
    filter: 'multi',
    group: 'Curso',
  },
  { id: 'curso', label: 'Curso', width: 280, sortable: true, filter: 'text', group: 'Curso' },
  { id: 'tipo', label: 'Tipo', width: 110, sortable: true, filter: 'multi', group: 'Curso' },
  {
    id: 'importe_suelto',
    label: 'Importe suelto',
    width: 140,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Importes',
  },
  {
    id: 'importe_nuevo_suelto',
    label: 'Importe nuevo suelto',
    width: 160,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Importes',
  },
  {
    id: 'precio_ciclo',
    label: 'Precio ciclo',
    width: 130,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Importes',
  },
  {
    id: 'precio_ciclo_nuevo',
    label: 'Precio ciclo nuevo',
    width: 150,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Importes',
  },
  { id: 'actions', label: 'Acciones', width: 72, fixed: true },
];

export const TABLA_PRECIOS = 'precios';
